import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import moment from "moment";
import {
  areArraysEqual,
  calculHt,
  calculTTC_Remise,
  calculTTc,
} from "../../../_App/Helpers/helpers";
import { ToastWarning } from "../../../Shared/Toasts/ToastWarning";
import { useAppDispatch, useAppSelector } from "../../../_App/Redux/hooks";
import {
  Listmatrice,
  findMatriceById,
} from "../../../_App/Redux/Slices/matrice/matriceSlice";
import Matrice from "../../Products/Products/ProductsForm/Matrice";
import MatriceAchat from "./MatriceAchat";
import { toast } from "react-toastify";
import TaxType from "../../../_App/Types/Entites/TaxType";
import ProductSelectComponent from "./ProductSelectComponent";
import { parametrageCaisse } from "../../../_App/Redux/Slices/AppParametrages/caisseParametrages/caisseParametrageSlice";
import { findProduitParArticleApi } from "../../../_App/Redux/Slices/produits/produitSlice";
export default function AchatFormTable({
  t,
  setShowModalProduct,
  setInputs,
  inputs,
  listProduits,
  societe,
  selecteddepots,
  options,
  listdepots,
  listtva,
  handleSelectChange,
  dispatch,
  selectedfournisseur,
  handleInputChange
}: any) {
  const list_matrice = useAppSelector(Listmatrice);
  const [ShowModalMatrice, setShowModalMatrice] = useState(false);
  const [selectedmatrice, setselectedmatrice] = useState({});
  const [qunatitetotal, setqunatitetotal] = useState(0);
  const [index, setindex] = useState(0);
  const [inputValue, setInputValue] = useState("");
  const parametrage_caisse = useAppSelector(parametrageCaisse);

  
  const getparent = (index: number) => {
    const inputligne = inputs[index];
    const parentIndex = inputs.findIndex(
      (item: any) =>
        item.type === "commentaire" &&
        item.product_id === inputligne.produit.produitparent
    );
    // Check if the item was found
    if (parentIndex !== -1) {
      const parentValue = inputs[parentIndex];

      setInputs((prevInputs: any) => {
        const newInputs = [...prevInputs];
        newInputs[parentIndex] = {
          ...newInputs[parentIndex],
          show: !parentValue.show,
        };
        return newInputs;
      });
    } else {
      console.log("Item not found");
    }
  };

  const removeitem = (index: number) => {
    setInputs((prevInputs: any) => {
      const newInputs = [...prevInputs];

      if (newInputs[index].type === "fils") {
        const inputligne = inputs[index];
        const parentIndex = inputs.findIndex(
          (item: any) =>
            item.type === "commentaire" &&
            item.product_id === inputligne.produit.produitparent
        );
        // Check if the item was found
        if (parentIndex !== -1) {
          const parentValue = inputs[parentIndex];

          // update detail parent
          const item = {
            dimension: inputligne.details[0].dimension,
            valeur: 0,
          };
          const ledetail = parentValue.details;

          // Filter out elements with equal dimensions
          const filteredDetails = ledetail.filter(
            (element: any) =>
              !areArraysEqual(
                element.dimension,
                inputligne.details[0].dimension
              )
          );
          const total = [...filteredDetails, item].reduce(
            (accumulator: any, item: any) => {
              return accumulator + (item.valeur || 0);
            },
            0
          );

          newInputs[parentIndex] = {
            ...newInputs[parentIndex],
            details: filteredDetails,
            quantite: total,
          };
        }
      }
      newInputs.splice(index, 1);

      return newInputs;
    });
  };

  const getmatrice = (matriceid: any, index: number) => {
    setqunatitetotal(inputs[index].quantite);
    const matrice = list_matrice.find((item) => item._id === matriceid);
    setindex(index);

    if (matrice) {
      setShowModalMatrice(true);
      setselectedmatrice(matrice);
    } else {
      toast.warning("le matrice n'existe pas");
    }
  };
  const lastKeyPressTime = useRef<number>(0);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const handleCodeBarreChange = async (inputValue: string) => {
    setInputValue(inputValue);
    const now = Date.now();
    const timeDiff = now - lastKeyPressTime.current;
    lastKeyPressTime.current = now;

    // Si le temps entre deux entrées est court, c'est probablement un scan
    const isScannerInput = timeDiff < 50;

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(
      async () => {
        const data = { code_a_barre: inputValue, societe: societe };

        const resp = await dispatch(findProduitParArticleApi(data));
        if (resp.payload && resp.payload !== null ) {
          console.log("object",resp.payload)
          handleSelectChange(resp.payload);
          setInputValue("");
        }else{
          ToastWarning(t('le produit n existe pas '))
        }
      },
      isScannerInput ? 100 : 1500
    );
  };
  return (
    <div className="table-responsive">
      <table className="table table-bordered mb-5">
        <thead>
          <tr>
            <th></th>
            <th>{t("Produit")}</th>
            <th>{t("Depots")}</th>
            <th>{t("Quantite")}</th>
            {parametrage_caisse.prix_achat && (
              <>
                <th>{t("Prix Achat HT")}</th>
                <th>{t("Prix Achat TTC")}</th>
              </>
            )}
            <th>{t("Remise")}</th>
            <th>{t("TVA")}</th>
            <th>{t("Total HT")}</th>
            <th>{t("Total TTC")}</th>
            <th>{t("Total Net TTC")}</th>
          </tr>
        </thead>

        {inputs.length !== 0 ? (
          <tbody>
            {inputs?.map((item: any, index: number) =>
              item.show ? (
                <tr key={item._id}>
                  <td onClick={() => removeitem(index)}>
                    {" "}
                    <i className="fas fa-trash-alt color-red" />
                  </td>

                  <td>
                    {" "}
                    {item.produit.type === "parent" &&
                    item.produit.matrice !== null ? (
                      <span
                        onClick={() => getmatrice(item.produit.matrice, index)}
                      >
                        <i className="fas fa-th-large"></i>
                      </span>
                    ) : item.type === "fils" ? (
                      <span onClick={() => getparent(index)}>
                        <i className="fab fa-product-hunt"></i>
                      </span>
                    ) : null}
                    {item.produit?.titre?.fr}
                  </td>
                  <td>
                    <select
                      className=""
                      onChange={(e) =>
                        handleInputChange(index, "depots_id", e.target.value)
                      }
                      value={inputs[index]?.depots_id}
                    >
                      {listdepots.map((item: any, index: number) => (
                        <option key={index} value={item._id}>
                          {item.libelle}
                        </option>
                      ))}
                    </select>
                  </td>

                  <td>
                    <input
                      type="number"
                      value={inputs[index]?.quantite || ""}
                      disabled={item.type === "commentaire"}
                      onChange={(e) =>
                        handleInputChange(index, "quantite", +e.target.value)
                      }
                      className="input-gray-border numberinput"
                    />
                  </td>
                  {parametrage_caisse.prix_achat && (
                    <>
                      <td>
                        <input
                          type="number"
                          disabled={item.type === "commentaire"}
                          value={inputs[index]?.prix_ht || ""}
                          onChange={(e) =>
                            handleInputChange(index, "prix_ht", +e.target.value)
                          }
                          className="input-gray-border numberinput"
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          disabled={item.type === "commentaire"}
                          value={inputs[index]?.prix_ttc || ""}
                          onChange={(e) =>
                            handleInputChange(
                              index,
                              "prix_ttc",
                              +e.target.value
                            )
                          }
                          className="input-gray-border numberinput"
                        />
                      </td>
                    </>
                  )}
                  <td>
                    <input
                      type="number"
                      disabled={item.type === "commentaire"}
                      value={inputs[index]?.remise || ""}
                      onChange={(e) =>
                        handleInputChange(index, "remise", +e.target.value)
                      }
                      className="input-gray-border numberinput"
                    />
                  </td>
                  <td>{item.tva}</td>
                  <td>{inputs[index]?.total_prix_ht?.toFixed(3) || 0}</td>
                  <td>{inputs[index]?.total_prix_ttc?.toFixed(3) || 0}</td>
                  <td>{inputs[index]?.total_net_ttc?.toFixed(3) || 0}</td>
                </tr>
              ) : null
            )}
          </tbody>
        ) : null}

        <tbody>
          <tr>
            <td onClick={() => setShowModalProduct(true)}>
              {" "}
              <span className="c-primary float-right my">
                <i className="fas fa-plus-circle fa-lg"></i>
              </span>
            </td>
            <td colSpan={2}>
              <input
                type="text"
                onChange={(e) => handleCodeBarreChange(e.target.value)}
                value={inputValue}
              />
            </td>
          </tr>
        </tbody>
      </table>
      <MatriceAchat
        t={t}
        ShowModal={ShowModalMatrice}
        setShowModal={setShowModalMatrice}
        matrice={selectedmatrice}
        quantite={qunatitetotal}
        setInputs={setInputs}
        index={index}
        inputs={inputs}
        listProduits={listProduits}
        taxes={listtva}
        selecteddepots={selecteddepots}
        societe={societe}
      />
    </div>
  );
}
